import React, { useState } from 'react';

const NETWORKS = [
  {
    idx: '01',
    name: 'Concierge',
    domain: 'concierge.momorox.com',
    desc: 'An assistant on your own site that answers patient questions and books the appointment — wired into your practice management and scheduling.',
    tags: 'PRACTICES · SOFTWARE →',
    href: 'https://concierge.momorox.com',
    highlight: true,
  },
  {
    idx: '02',
    name: 'Free Dental Samples',
    domain: 'freedentalsamples.com',
    desc: 'Request free samples from Dandy, NOBS, Mouthology and Flaus — shipped to the practice, no rep visit.',
    tags: 'PRACTICES · BRANDS →',
    href: 'https://freedentalsamples.com',
  },
  {
    idx: '03',
    name: 'Best Dental Labs',
    domain: 'bestdentallabs.org',
    desc: 'Certified labs by specialty, state and turnaround — implants, dentures, ortho, full arch. NBC and DAMAS credentials checked, not claimed.',
    tags: 'PRACTICES · LABS →',
    href: 'https://bestdentallabs.org',
  },
  {
    idx: '04',
    name: 'Best Dental Software',
    domain: 'bestdentalsoftware.org',
    desc: 'Practice management, imaging and patient comms compared by the practices actually running them. What integrates with what, before you sign.',
    tags: 'PRACTICES · VENDORS →',
    href: 'https://bestdentalsoftware.org',
  },
];

function NetworkRow({ item }) {
  const [hovered, setHovered] = useState(false);
  const active = item.highlight || hovered;
  return (
    <a
      href={item.href}
      target="_blank"
      rel="noopener noreferrer"
      className="mx-network-row"
      style={{ background: active ? '#dcedc2' : 'transparent' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span style={{ font: '500 12px "IBM Plex Mono",monospace', color: '#2a2a2a' }}>{item.idx}</span>
      <span>
        <span style={{ display: 'block', font: '600 27px Archivo,sans-serif', letterSpacing: '-.02em', color: '#111' }}>{item.name}</span>
        <span style={{ display: 'block', font: '400 12px "IBM Plex Mono",monospace', color: '#2a2a2a', marginTop: '6px' }}>{item.domain}</span>
      </span>
      <span className="mx-network-desc" style={{ font: '400 15px/1.55 Archivo,sans-serif', color: '#2a2a2a' }}>{item.desc}</span>
      <span className="mx-network-tags" style={{ font: '400 12px "IBM Plex Mono",monospace', color: '#111', textAlign: 'right' }}>{item.tags}</span>
    </a>
  );
}

export default function Products() {
  return (
    <div id="networks" style={{ background: '#f3f9e9' }}>
      <div className="mx-networks-head">
        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: '8px' }}>
          <h2 style={{ margin: 0, font: '600 15px "IBM Plex Mono",monospace', letterSpacing: '.1em', color: '#111' }}>THE NETWORKS</h2>
          <span style={{ font: '400 13px Archivo,sans-serif', color: '#2a2a2a' }}>What MomoroX runs today.</span>
        </div>
      </div>
      <div className="mx-networks-pad">
        <div style={{ borderTop: '1px solid #111' }}>
          {NETWORKS.map(item => <NetworkRow key={item.idx} item={item} />)}
        </div>
      </div>
    </div>
  );
}
